import { fluid } from '@helpers/fluid';
import styled from 'styled-components';
import { DotsStyles } from '../Dots/Dots.styles';
const Container = styled.div `
  display: flex;
  align-items: center;
  gap: ${fluid(16, 24)};

  ${DotsStyles.Dots} {
    flex: 1;
  }
`;
const PaginationStyles = {
    Container,
};
export default PaginationStyles;
